import { Box, Stack, Typography } from "@mui/material";
import React from "react";

type PageHeaderProps = {
  title: React.ReactNode,
  subtitle?: React.ReactNode,
  tag?: React.ReactNode,
  children?: React.ReactNode,
  noMarginBottom?: boolean
}

export default function PageHeader({ title, subtitle, children, tag, noMarginBottom = false }: PageHeaderProps) {
  return <Box sx={noMarginBottom ? {} : { mb: 2 }}>
    <Stack direction={{ md: "row" }} alignItems="center">
      <Box sx={{ flexGrow: 1, display: "flex", direction: "row", gap: 1, flexWrap: "wrap" }}>
        <Box display="inline-block">
          <Typography variant="h4">
            {title}
          </Typography>
          {subtitle}
        </Box>


        <Box sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center"
        }}>
          {tag}
        </Box>
      </Box>

      {
        children && <Box sx={{ flexShrink: 0, flexDirection: { xs: "column", md: "row" } }} display="flex" flexWrap="wrap" gap={1} width={{ xs: "100%", md: "initial" }}>
          {children}
        </Box>
      }
    </Stack >
  </Box >
}